import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const Stationary = ({ color, big }) => {
  return (
    <svg width={big ? "100px" : "50px"} height={big ? "102px" : "51px"} viewBox="0 0 50 51" version="1.1">
      <defs>
        <path
          d="M9.99166667,16.56 L21.0833333,16.56 L19.8916667,18.4 L11.1833333,18.4 L9.99166667,16.56 Z M20.5333333,19.136 C20.4416667,19.228 20.35,19.32 20.1666667,19.32 L11,19.32 C10.8166667,19.32 10.725,19.228 10.6333333,19.136 L9.16666667,16.928 L9.16666667,23 L22,23 L22,16.928 L20.5333333,19.136 Z M13.75,8.28 L21.0833333,8.28 L21.0833333,12.88 L13.75,12.88 L13.75,8.28 Z M14.6666667,10.58 C14.6666667,10.856 14.85,11.04 15.125,11.04 C15.4,11.04 15.5833333,10.856 15.5833333,10.58 C15.5833333,10.304 15.4,10.12 15.125,10.12 C14.85,10.12 14.6666667,10.304 14.6666667,10.58 Z M9.16666667,15.64 C8.61666667,15.64 8.25,16.008 8.25,16.56 L8.25,23 L1.375,23 C0.641666667,23 0,22.356 0,21.62 L0,1.38 C0,0.644 0.641666667,0 1.375,0 L16.9583333,0 C17.6916667,0 18.3333333,0.644 18.3333333,1.38 L18.3333333,7.36 L13.75,7.36 C13.2,7.36 12.8333333,7.728 12.8333333,8.28 L12.8333333,12.88 C12.8333333,13.432 13.2,13.8 13.75,13.8 L18.3333333,13.8 L18.3333333,15.64 L9.16666667,15.64 Z M15.5833333,5.06 C15.5833333,4.784 15.4,4.6 15.125,4.6 L12.375,4.6 C12.1,4.6 11.9166667,4.784 11.9166667,5.06 C11.9166667,5.336 12.1,5.52 12.375,5.52 L15.125,5.52 C15.4,5.52 15.5833333,5.336 15.5833333,5.06 Z M10.0833333,3.22 C10.0833333,3.496 10.2666667,3.68 10.5416667,3.68 L15.125,3.68 C15.4,3.68 15.5833333,3.496 15.5833333,3.22 C15.5833333,2.944 15.4,2.76 15.125,2.76 L10.5416667,2.76 C10.2666667,2.76 10.0833333,2.944 10.0833333,3.22 Z M6.41666667,4.6 C6.41666667,3.588 5.59166667,2.76 4.58333333,2.76 C3.575,2.76 2.75,3.588 2.75,4.6 C2.75,5.612 3.575,6.44 4.58333333,6.44 C5.59166667,6.44 6.41666667,5.612 6.41666667,4.6 Z"
          id="path-1"
        />
        <filter
          x="-104.5%"
          y="-82.6%"
          width="309.1%"
          height="300.0%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="4"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="7"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.443137255   0 0 0 0 0.843137255   0 0 0 0 0.48627451  0 0 0 0.409250453 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g
        // id="desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          // id="New-flow_06_filled-Copy"
          transform="translate(-296.000000, -81.000000)"
        >
          <g
            // id="budicon-office-stationary"
            transform="translate(310.000000, 91.000000)"
          >
            <g id="Shape">
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-2)"
                xlinkHref="#path-1"
              />
              <use fill={color} fillRule="evenodd" xlinkHref="#path-1" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

Stationary.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

Stationary.propTypes = {
  color: PropTypes.string
}

export default Stationary
